import { ReactElement, ReactNode } from "react";
import { ContainerProps, FlexProps, HeadingProps } from "@chakra-ui/react";

import { ContentContainer } from "../atoms/ContentContainer";
import { PageHeader } from "../organisms/PageHeader";

type BasicPageLayoutProps = ContainerProps & {
  title?: ReactNode;
  titleContainerProps?: FlexProps;
  titleProps?: HeadingProps;
  showBackButton?: boolean;
  showBackToHomeButton?: boolean;
  onBack?: () => void;
};

export function BasicPageLayout(props: BasicPageLayoutProps): ReactElement {
  const {
    title,
    titleContainerProps,
    titleProps,
    showBackButton = false,
    showBackToHomeButton = false,
    onBack,
    children,
    ...containerProps
  } = props;

  const hasTitle = title !== undefined;

  return (
    <ContentContainer
      px={{ base: 5, md: 10 }}
      pt={hasTitle ? 0 : { base: 3, md: 6 }}
      pb={{ base: 3, md: 6 }}
      {...containerProps}
    >
      {hasTitle && (
        <PageHeader
          title={title}
          titleContainerProps={titleContainerProps}
          titleProps={titleProps}
          showBackButton={showBackButton}
          showBackToHomeButton={showBackToHomeButton}
          onBack={onBack}
        />
      )}
      {children}
    </ContentContainer>
  );
}
